// apiClientInterceptor.js
import axios from "axios";
import { store } from "../sagas";
import { refreshTokenRequest } from "../actions/auth";
import { auth } from "../../Utils/auth";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: { Accept: "application/json", "Content-Type": "application/json" },
});

// Request interceptor to add the access token to headers
axiosInstance.interceptors.request.use((config) => {
  const token = auth.getToken();
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor to handle 401 errors (token expiry)
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    console.log("error.response.status", error?.response);
    if (error?.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        // Dispatch refresh token action
        await store.dispatch(refreshTokenRequest());
        const newToken = auth.getToken();
        originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
        return axiosInstance(originalRequest);
      } catch (refreshError) {
        // Handle refresh token failure
        console.error("Refresh token failed", refreshError);
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
